import React from 'react'
import { Routes, Route, Link } from "react-router-dom";
function Footer() {
  return (
    <>
     <div className='bg-danger'>
      <div className='container'>
        <div className='row p-5'>
            <div className='col-lg-6'>
                <h1 className='text-light'>Subscribe Our Newsletter</h1>
            </div>
            <div className='col-lg-6'>
            <form className="d-flex" role="search">
              <input className="form-control py-3" type="search" placeholder="Your email" aria-label="Search" />
              <button type="button" className=" btn btn-dark dam px-4 py-3">Subscribe</button>
            </form>
            </div>
        </div>
      </div>
    </div>
     <footer className=" border-top bg-dark text-light">
  <div className="container">
    <div className="row pt-5">
      <div className="col-lg-3 text-start">
      <a className="navbar-brand" href="#"><img src={require('../images/logo_light.png')}/></a>
        <p className='py-4'>If you are going to use of Lorem Ipsum need to be sure there isn't hidden of text</p>
        <div className='links py-2'>
        <Link to='facebook.com'><i className="bi bi-facebook a"></i></Link>
        <Link to='twitter.com'><i class="bi bi-twitter a"></i></Link>
        <Link to='google.com'><i class="bi bi-google a"></i></Link>
        <Link to='youtube.com'><i class="bi bi-youtube a"></i></Link>
        <Link to='instagram.com'><i class="bi bi-instagram a"></i></Link>
        </div>
      </div>
      <div className="col-lg-2 col-sm-6">
        <h5 className='fw-bold pb-3'>Useful Links</h5>
        <ul className='pb-3 ps-0 lh-lg text-light new'>
       <li className='pb-2 fw-normal'><a href='/'>About Us</a></li>
       <li className='pb-2 fw-normal'><a href='/'>FAQ</a></li>
       <li className='pb-2 fw-normal'><a href='/'>Location</a></li>
       <li className='pb-2 fw-normal'><a href='/'>Affiliates</a></li> 
       <li className='pb-2 fw-normal'><a href='/'>Contact</a></li>     
       </ul>
      </div>
      <div className="col-lg-2 col-sm-6">
        <h5 className='fw-bold pb-3'>Category</h5>
        <ul className='pb-3 ps-0 lh-lg text-light new'>
       <li className='pb-2 fw-normal'><a href='/'>Men</a></li>
       <li className='pb-2 fw-normal'><a href='/'>Woman</a></li>
       <li className='pb-2 fw-normal'><a href='/'>Kids</a></li>
       <li className='pb-2 fw-normal'><a href='/'>Best Saller</a></li> 
       <li className='pb-2 fw-normal'><a href='/'>New Arrivals</a></li>     
       </ul>
      </div>
      <div className="col-lg-2 col-sm-6 mt-sm-3 mt-lg-0">
        <h5 className='fw-bold pb-3'>My Account</h5>
        <ul className='pb-5 ps-0 lh-lg text-light new'>
       <li className='pb-2 fw-normal'><a href='/'>My Account</a></li>
       <li className='pb-2 fw-normal'><a href='/'>Discount</a></li>
       <li className='pb-2 fw-normal'><a href='/'>Returns</a></li>
       <li className='pb-2 fw-normal'><a href='/'>Orders History</a></li> 
       <li className='pb-2 fw-normal'><a href='/'>Order Tracking</a></li>     
       </ul>
      </div>
      <div className="col-lg-3 col-sm-6 mt-sm-3 abc mt-lg-0">
        <h5 className='fw-bold pb-3'>Contact Info</h5>
        <ul className='pb- ps-0 lh-lg text-light new'>
       <li className='pe-5 fw-normal'><div className='d-flex'>
        <i class="bi bi-geo-alt a me-3"></i>
        <p className='fw-normal'> 123 Street, Old Trafford, New South London , UK</p>
        </div></li>
       <li className='pe-5 fw-normal py-3'>
       <i class="bi bi-envelope a me-3"></i>
        <a href='/'> info@sitename.com</a></li>
        <li className='pe-5 fw-normal'><div className='d-flex'>
        <i class="bi bi-phone a me-3"></i>
        <p className='fw-normal'>+ 457 789 789 65</p>
        </div></li>
       </ul>
      </div>
    </div> 
  </div>
   <hr/> 
  <section className="pt-4">
    <div className="container">
        <div className='row'>
            <div className='col-lg-6 text-sm-center text-lg-start'>
            <p>© 2020 All Rights Reserved by Bestwebcreator</p> 
            </div>
            <div className='col-lg-6'>
            <ul className='pb-3 ps-0 lh-lg text-light new d-flex float-end me-sm-5 me-lg-0 mt-sm-3 mt-lg-0'>
       <li className='pb-2 fw-normal'><a href='/'><img className='pe-1' src={require('../images/visa.png')}/></a></li>
       <li className='pb-2 fw-normal'><a href='/'><img className='pe-1' src={require('../images/discover.png')}/></a></li>
       <li className='pb-2 fw-normal'><a href='/'><img className='pe-1' src={require('../images/master.png')}/></a></li>
       <li className='pb-2 fw-normal'><a href='/'><img className='pe-1' src={require('../images/paypal.png')}/></a></li>
       <li className='pb-2 fw-normal'><a href='/'><img className='pe-1' src={require('../images/amarican.png')}/></a></li>  
       </ul>
            </div>
        </div> 
    </div>
  </section>  
</footer>
    </>
  )
}

export default Footer